interface Slide {
  imageUrl: string;
  mobileImageUrl: string;
  tabletImageUrl: string;
}

const getResponsiveImageUrl = (slide: Slide) => {
  const isMobile = window.innerWidth < 768;
  const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;

  if (isMobile && slide.mobileImageUrl) {
    return slide.mobileImageUrl;
  } else if (isTablet && slide.tabletImageUrl) {
    return slide.tabletImageUrl;
  }
  return slide.imageUrl; // Desktop version
};

export default getResponsiveImageUrl;
